module.exports = __webpack_public_path__ + "media/events/RoadShow2020-d141339a.png";